import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Pagination from '@ey/canvascoreservices/Pagination';
import PaginationSelect from '@ey/motif-react-wrapper/PaginationSelect';
import PaginationSelectItem from '@ey/motif-react-wrapper/PaginationSelectItem';
import {currentResource} from '../../../util/uiconstants';

export default function PaginationMotif(props) {
	const {
		currentPage,
		options,
		pageSize = 20,
		onPageChange,
		onPageSizeChange,
		onDropdownChange,
		options_per_page,
		totalPages,
		pageCount
	} = props;
	const [itemsPerPage, setItemsPerPage] = React.useState(pageSize);
	return (
		<Pagination
			optionsPerPage={options || options_per_page}
			{...props}
			page={currentPage || 1}
			onPageChanged={onPageChange}
			onPageSizeChanged={(size) => {
				setItemsPerPage(size);
				onPageSizeChange && onPageSizeChange(size);
				onDropdownChange && onDropdownChange(size);
			}}
			pageSize={itemsPerPage}
			pageCount={totalPages || pageCount || 1}
			paginationButtonLabels={currentResource.common.pagination.iconHover}
			paginationSelectLabel={currentResource.common.pagination.show}
		/>
	);
}

Pagination.defaultProps = {
	currentPage: 1,
	min: 1,
	max: 1,
	options: null, // [20, 50, 100, 200],
	pageSize: 20,
	onPageChange: () => {},
	onPageSizeChange: () => {},
	className: '',
	paginationButtonLabels: {
		first: 'first',
		last: 'last',
		previous: 'previous',
		next: 'next'
	}
};

Pagination.propTypes = {
	currentPage: PropTypes.number,
	min: PropTypes.number,
	max: PropTypes.number,
	pageSize: PropTypes.number,
	onPageChange: PropTypes.func,
	onPageSizeChange: PropTypes.func,
	className: PropTypes.string
};

const StyledPagination = styled.div``;
